export default class Select2 {
	constructor($module) {
		this.$module = $module;

		$(document).ready(function() {
			$('.js-example-basic-single').select2();
			theme: "bc-select2";

		});
		
	}
}
